export default "__VITE_ASSET__BVkIOe74__"